export class CardItem {
    public id: string;
    public title: string;
    public description: string;
    public icon: string;
    public image: string;
    public active: boolean = true;

    constructor(fields?: Partial<CardItem>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/card-list/models/card-item.ts